import { lazy, Suspense } from 'react';

import { BrowserRouter, Route, Routes as Switch } from 'react-router-dom';

import { ErrorBoundary } from 'react-error-boundary';

import { QueryClient, QueryClientProvider } from 'react-query';

import Loader from 'src/components/Loader';

const Home = lazy(() => import('src/pages/Home'));
const Exames = lazy(() => import('src/pages/Exames'));
const Laudos = lazy(() => import('src/pages/Laudos'));
const Private = lazy(() => import('src/pages/Private'));
const LoginPage = lazy(() => import('src/pages/LoginPage'));
const Convenios = lazy(() => import('src/pages/Convenios'));
const FallbackUI = lazy(() => import('src/pages/Errors/FalbackUI'));
const EsqueciSenha = lazy(() => import('src/pages/EsqueciSenha'));
const LoginPageSite = lazy(() => import('src/pages/LoginPageSite'));
const UnidadesColeta = lazy(() => import('src/pages/UnidadesColeta'));
const NotFound404 = lazy(() => import('src/pages/Errors/NotFound404'));

const MasterPageLab = lazy(() => import('src/components/MasterPageLab'));
const MasterPageResultados = lazy(
  () => import('src/components/MasterPageResultados'),
);

const AuthProvider = lazy(() => import('src/Context/AuthContext').then((module) => ({
  default: module.AuthProvider,
})));
const ConfigProvider = lazy(() => import('src/Context/ConfigContext').then((module) => ({
  default: module.ConfigProvider,
})));

export function Router() {
  // Create a client
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1, // Número máximo de tentativas de busca
        refetchOnWindowFocus: false,
        // Evita que a busca seja refeita quando a janela estiver em foco novamente
        cacheTime: 60000, // Tempo de cache em milissegundos (60 segundos)
        staleTime: 30000, // Tempo em milissegundos antes de considerar os dados como obsoletos
      },
    },
  });

  return (
    <ErrorBoundary FallbackComponent={FallbackUI}>
      <Suspense fallback={<Loader isLoading />}>
        <BrowserRouter basename={process.env.REACT_APP_BASE_ROUTE}>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <ConfigProvider>
                <Switch>
                  {/* Páginas referentes a resultados dos exames Online */}
                  <Route path="/default" element={<LoginPage />} />
                  <Route path="/default.aspx" element={<LoginPage />} />
                  <Route path="/acao.aspx" element={<LoginPage />} />
                  <Route path="/esqueciasenha" element={<EsqueciSenha />} />
                  <Route path="/Laudos/:id/" element={<Laudos />} />
                  <Route path="/Laudos/:id/:id2" element={<Laudos />} />
                  {process.env.REACT_APP_POSSUI_SITE === 'false' ? (
                    <Route
                      path="/"
                      element={(
                        <Private>
                          <MasterPageResultados />
                        </Private>
                      )}
                    >
                      <Route path="" element={<Home />} />
                    </Route>
                  ) : (
                    <>
                      <Route path="/" element={<MasterPageLab />}>
                        <Route path="" element={<LoginPageSite />} />
                        <Route path="exames" element={<Exames />} />
                        <Route path="unidades" element={<UnidadesColeta />} />
                        <Route path="convenios" element={<Convenios />} />
                      </Route>
                      <Route
                        path="/resultados"
                        element={(
                          <Private>
                            <MasterPageResultados />
                          </Private>
                        )}
                      >
                        <Route path="" element={<Home />} />
                      </Route>
                    </>
                  )}
                  <Route path="*" element={<NotFound404 />} />
                </Switch>
              </ConfigProvider>
            </AuthProvider>
          </QueryClientProvider>
        </BrowserRouter>
      </Suspense>
    </ErrorBoundary>
  );
}
